import {IParametroFacConver} from './../modelos/IParametroFacConver';
import {CommonService} from './../../../shared/utils/common.service';
import {UtilsService} from './../../../shared/utils/utils.service';
import {Injectable} from '@angular/core';
import {moduloGaritas} from '../diccionarios/balanzaModulo.js';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ParametroFactorConversionService {
  private diccionarioModulo: any;
  private url: string;

  constructor(private _util: UtilsService, private _commom: CommonService) {
    this.diccionarioModulo = moduloGaritas;
    this.url = this._util.getUrlBascula();
  }

  obtener(): Observable<IParametroFacConver[]> {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.paramFacConver.obtenerTodo
    );
  }

  obtenerPorId(idGarita: number): Observable<IParametroFacConver> {
    return this._commom.peticionGetConHeader(
      this.url +
      this.diccionarioModulo.url.paramFacConver.obtenerPorId +
      idGarita
    );
  }

  crear(request: IParametroFacConver) {
    return this._commom.peticionPostConHeader(
      this.url + this.diccionarioModulo.url.paramFacConver.crear,
      request
    );
  }

  actualizar(request: IParametroFacConver): Observable<any> {
    return this._commom.peticionPutConHeader(
      this.url + this.diccionarioModulo.url.paramFacConver.actualizar,
      request
    );
  }

  borrar(idGarita: number): Observable<any> {
    return this._commom.peticionDeleteConHeader(
      this.url + this.diccionarioModulo.url.paramFacConver.eliminar + idGarita
    );
  }
}
